<template>
  <div>
    <div class="tabel-bar">
      <div class="tabel-bar-left">
        <el-button type="primary" :size="$store.state.buttonSize" @click="batchPopup()">新增填报</el-button>
        <RemoveButton
          type="info"
          @click="handleRemoveAll"
          :disabled="!selectionID.length"
        >批量删除</RemoveButton>
      </div>
      <div class="tabel-bar-right">
        <el-input
          placeholder="请输入内容"
          :size="$store.state.formSize"
          prefix-icon="el-icon-search"
          v-model="keywords"
          @input="search"
        ></el-input>
        <el-tooltip effect="dark" content="刷新列表" placement="bottom">
          <span class="el-icon-refresh icon-hover refresh-btn" @click="debounceRefresh"></span>
        </el-tooltip>
      </div>
    </div>
    <el-table v-loading="loading" :data="tableData" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column prop="checkReportName" label="检验报告名称"></el-table-column>
      <el-table-column prop="checkOrg" label="检验单位"></el-table-column>
      <el-table-column prop="manager" label="负责人"></el-table-column>
      <el-table-column prop="checkItemsId" label="检验项"></el-table-column>
      <el-table-column prop="checkVal" label="检验值"></el-table-column>
      <el-table-column prop="referenceVal" label="参考值"></el-table-column>
      <el-table-column prop="productionDate" label="检验日期">
        <template slot-scope="scope">{{ scope.row.checkDate | formatDate }}</template>
      </el-table-column>
      <el-table-column prop="checkResult" label="检验报告结论">
        <template slot-scope="scope">
          <template v-if="scope.row.checkResult === 1">
            <el-tag type="success">合格</el-tag>
          </template>
          <template v-else>
            <el-tag type="danger">不合格</el-tag>
          </template>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="120">
        <template slot-scope="scope">
          <el-button type="text" @click="batchPopup(scope.row.id)">编辑</el-button>
          <el-button type="text" @click="batchDel(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="page"
      :page-size="size"
      :total="total"
    ></pagination>
    <!-- 弹出层 -->
    <el-dialog
      :close-on-click-modal="false"
      :append-to-body="true"
      :title="title"
      :visible.sync="checkFormVisible"
      center
      width="60%"
    >
      <el-form
        :model="checkForm"
        :size="$store.state.formSize"
        :rules="checkFormRules"
        ref="refcheckForm"
        label-width="140px"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item label="检验报告名称：" prop="checkReportName">
              <el-input v-model="checkForm.checkReportName"></el-input>
            </el-form-item>
            <el-form-item label="检验单位：" prop="checkOrg">
              <el-input v-model="checkForm.checkOrg"></el-input>
            </el-form-item>
            <el-form-item label="检验报告结论：" prop="checkResult">
              <el-select
                v-model="checkForm.checkResult"
                style="width:100%;"
                placeholder="请选择检验报告结论"
              >
                <el-option
                  v-for="item in checkResultList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="检验日期：" prop="checkDate">
              <el-date-picker
                v-model="checkForm.checkDate"
                value-format="yyyy-MM-dd"
                autocomplete="off"
                type="date"
                style="width:100%"
                :placeholder="checkForm.checkDate"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="负责人：" prop="manager">
              <el-input v-model="checkForm.manager"></el-input>
            </el-form-item>
            <el-form-item label="报告图片：" prop="checkReportImg">
              <el-upload
              action="#"
              list-type="picture-card"
              :limit="parseInt('1')"
              :http-request="handleHttpRequest"
              :before-upload="beforeAvatarUpload"
              :on-change="uploadChange"
              :on-remove="uploadRemove"
              :class="{hide:hideUpload}"
              ref="upload"
              :file-list="initFile">
                <i slot="default" class="el-icon-plus"></i>
                <div slot="file" slot-scope="{file}">
                  <img
                    class="el-upload-list__item-thumbnail" :src="checkForm.checkReportImgUrl"
                  >
                  <span class="el-upload-list__item-actions">
                    <span
                      class="el-upload-list__item-preview"
                      @click="handlePictureCardPreview(file)"
                    >
                      <i class="el-icon-zoom-in"></i>
                    </span>
                    <span
                      v-if="!disabled"
                      class="el-upload-list__item-delete"
                      @click="handleRemove(file)"
                    >
                      <i class="el-icon-delete"></i>
                    </span>
                  </span>
                </div>
            </el-upload>
            <Dialog :visible.sync="dialogVisible">
              <img width="100%" :src="dialogImageUrl" alt="">
            </Dialog>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="检验项：" prop="checkItemsId">
              <el-select v-model="checkForm.checkItemsId" style="width:100%;" placeholder="请选择检验项">
                <el-option
                  v-for="item in checkItemsList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="检验值：" prop="checkVal">
              <el-input v-model="checkForm.checkVal"></el-input>
            </el-form-item>
            <el-form-item label="参考值：" prop="referenceVal">
              <el-input v-model="checkForm.referenceVal"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class="text-center">
        <el-button type="primary" :size="$store.state.buttonSize" :disabled="isDisabled" @click="debounceSubmit">确 定</el-button>
        <el-button :size="$store.state.buttonSize" @click="hanleResetFormVals">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import moment from 'moment'
import { postWfsImg, wfsImgUrl } from '@/api/common'
import { debounce } from 'throttle-debounce'
import {
  getBatchCheckList,
  delBatchCheckList,
  deleteBatchCheckDel,
  postBatchCheckEdit,
  putBatchCheckAdd,
  getBatchCheckDetail,
  getCheckitemsList
} from '@/api/batchmanage'

const createForm = () => ({
  // *批次ID
  batchId: null,
  // *检验时间
  checkDate: '',
  // *负责人
  manager: '',
  // *检验报告结论:选择- 1：合格；0：不合格
  checkResult: 1,
  // *检验单位
  checkOrg: '',
  // *报告图片
  checkReportImg: '',
  checkReportImgUrl: '',
  // *报告名称
  checkReportName: '',
  // *检验项
  checkItemsId: null,
  // *检验值
  checkVal: '',
  // *参考值
  referenceVal: ''
})

export default {
  data() {
    return {
      selectionID: [],
      checkItemsList: [],
      checkFormVisible: false,
      isDisabled: false,
      total: 0,
      size: 10,
      page: 1,
      initFile: [],
      disabled: false,
      dialogImageUrl: '',
      hideUpload: false,
      dialogVisible: false,
      limitCount: 1,
      keywords: '',
      currentID: null,
      loading: true,
      tableData: [],
      checkForm: createForm(),
      checkResultList: [
        {
          id: 0,
          value: 0,
          label: '不合格'
        },
        {
          id: 1,
          value: 1,
          label: '合格'
        }
      ],
      checkFormRules: {
        checkDate: [
          { required: true, message: '请选择检验时间', trigger: 'blur' }
        ],
        checkResult: [
          { required: true, message: '请选择检验报告结论', trigger: 'blur' }
        ],
        manager: [
          { required: true, message: '请输入负责人', trigger: 'blur' }
        ],
        checkOrg: [
          { required: true, message: '请输入检验单位', trigger: 'blur' }
        ],
        checkReportImg: [
          { required: true, message: '请选择报告图片', trigger: 'blur' }
        ],
        checkReportName: [
          { required: true, message: '请输入检验报告名称', trigger: 'blur' }
        ],
        checkItemsId: [
          { required: true, message: '请选择检验项', trigger: 'blur' }
        ],
        checkVal: [
          { required: true, message: '请输入检验值', trigger: 'blur' }
        ],
        referenceVal: [
          { required: true, message: '请输入参考值', trigger: 'blur' }
        ]
      }
    }
  },
  props: {
    batchId: Number,
    productId: Number
  },
  computed: {
    title() {
      return this.currentID ? '编辑检验项' : '新增检验项'
    }
  },
  created() {
    this.debounceRefresh = debounce(300, this.refresh)
    this.debounceSubmit = debounce(300, this.batchSubmit)
  },
  methods: {
    handleHttpRequest(option) {
      const formData = new FormData()
      if (option.data) {
        Object.keys(option.data).forEach(key => {
          formData.append(key, option.data[key])
        })
      }
      formData.append(option.filename, option.file)
      postWfsImg(formData).then(res => {
        if (res.status === 1) {
          this.checkForm.checkReportImg = res.data.filePath
          this.checkForm.checkReportImgUrl = wfsImgUrl(res.data.filePath)
          this.initFile.push({ name: '1', url: wfsImgUrl(res.data.filePath) })
        } else {
          this.$message.error(res.msg || '图片上传失败')
        }
      }).catch(() => {
        this.$message.error('图片上传失败')
      })
    },
    uploadChange(file, fileList) {
      console.log(fileList)
      this.hideUpload = fileList.length >= this.limitCount
    },
    uploadRemove(file, fileList) {
      this.hideUpload = fileList.length >= this.limitCount
    },
    handleRemove(file) {
      this.checkForm.checkReportImg = ''
      this.initFile = []
      this.$refs.upload.handleRemove(file)
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    beforeAvatarUpload(file) {
      const isType = /^image\/(jpeg|png|jpg|bmp)$/.test(file.type)
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isType) {
        this.$message.error('请选择图片文件进行上传!')
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!')
      }
      return isType && isLt2M
    },
    hanleResetFormVals() {
      this.$set(this, 'checkForm', createForm())
      this.$refs.refcheckForm.clearValidate()
      this.checkFormVisible = false
    },
    handleSelectionChange(selection) {
      this.selectionID = selection.map(_ => _.id)
    },
    handleRemoveAll() {
      delBatchCheckList(this.selectionID).then(res => {
        if (res.status === 1) {
          this.$message.success('删除成功')
          this.getBatchCheckListData()
        } else {
          this.$message.error(res.msg)
          return false
        }
      })
    },
    // 分页
    handleSizeChange(val) {
      this.size = val
      this.getBatchCheckListData()
    },
    handleCurrentChange(val) {
      this.page = val
      this.getBatchCheckListData()
    },
    // 删除批次
    batchDel(id) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          deleteBatchCheckDel(id).then(res => {
            if (res.status === 1) {
              this.$message.success('删除批次成功')
              this.getBatchCheckListData()
            } else {
              this.$message.error(res.msg)
              return false
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 提交表单
    batchSubmit() {
      this.$refs.refcheckForm.validate(valid => {
        if (!valid) return false
        const batchItems = this.currentID
          ? postBatchCheckEdit
          : putBatchCheckAdd
        batchItems({
          checkResult: this.checkForm.checkResult,
          checkReportImg: this.checkForm.checkReportImg,
          checkReportImgUrl: this.checkForm.checkReportImgUrl,
          checkReportName: this.checkForm.checkReportName,
          checkItemsId: this.checkForm.checkItemsId,
          checkOrg: this.checkForm.checkOrg,
          manager: this.checkForm.manager,
          checkDate: this.checkForm.checkDate,
          checkVal: this.checkForm.checkVal,
          referenceVal: this.checkForm.referenceVal,
          batchId: this.batchId,
          id: this.currentID || undefined
        }).then(res => {
          if (res.status === 1) {
            this.currentID
              ? this.$message.success('编辑批次成功')
              : this.$message.success('新增批次成功')
            this.getBatchCheckListData()
            this.checkFormVisible = false
          } else {
            this.$message.error(res.msg)
            return false
          }
        })
      })
    },
    // 打开表单层
    batchPopup(id) {
      this.initFile = []
      this.hideUpload = false
      this.$set(this, 'checkForm', createForm())
      const isAdd = !id
      this.checkFormVisible = true
      if (isAdd) {
        this.currentID = null
      } else {
        this.isDisabled = true
        getBatchCheckDetail(id).then(res => {
          if (res.status === 1) {
            this.currentID = id
            this.checkForm.checkResult = res.data.checkResult
            this.checkForm.manager = res.data.manager
            this.checkForm.checkDate = moment(res.data.checkDate).format(
              'YYYY-MM-DD'
            )
            this.checkForm.checkItemsId = res.data.checkItemsId
            this.checkForm.checkOrg = res.data.checkOrg
            this.checkForm.checkVal = res.data.checkVal
            this.checkForm.checkReportName = res.data.checkReportName
            this.checkForm.checkReportImg = res.data.checkReportImg
            this.checkForm.referenceVal = res.data.referenceVal
            this.checkForm.batchId = res.data.batchId
            if (res.data.checkReportImgUrl) {
              this.checkForm.checkReportImgUrl = res.data.checkReportImgUrl
              this.initFile.push({ name: '1', url: res.data.checkReportImgUrl })
              this.hideUpload = true
            } else {
              this.hideUpload = false
            }
            this.isDisabled = false
          } else {
            this.$message.error(res.msg)
          }
        })
      }
    },
    // 检索
    search() {
      this.getBatchCheckListData()
    },
    // 刷新数据表格
    refresh() {
      this.getBatchCheckListData()
      this.$message.success('数据刷新成功')
    },
    // 获取批次检验项列表
    getBatchCheckListData() {
      console.log(this.batchId)
      this.loading = true
      getBatchCheckList({
        page: this.page,
        size: this.size,
        batchId: this.batchId
      }).then(res => {
        console.log(res)
        if (res.status === 1) {
          this.total = res.data.total
          this.tableData = res.data.rows
        } else {
          this.$message.error(res.msg)
        }

        this.loading = false
      })
    },
    // 获取产品检验项列表
    getCheckItemsData() {
      console.log(this.productId)
      getCheckitemsList({
        page: 1,
        size: 1000,
        productId: this.productId
      }).then(res => {
        console.log(res)
        if (res.status === 1) {
          const arr = []
          for (let i = 0; i < res.data.rows.length; i++) {
            arr.push({
              label: res.data.rows[i].checkName,
              value: res.data.rows[i].id
            })
          }
          this.checkItemsList = arr
        } else {
          this.$message.error(res.msg)
        }
      })
    }
  },
  mounted() {
    this.getBatchCheckListData()
    this.getCheckItemsData()
  },
  filters: {
    format(value) {
      return moment(value).format('YYYY-MM-DD HH:mm:ss')
    },
    formatDate(value) {
      return moment(value).format('YYYY-MM-DD')
    }
  }
}
</script>
<style lang="scss">
.hide .el-upload--picture-card {
    display: none;
}
</style>
